(function () {
  'use strict';

  // ─── Sécurité : ne rien faire si le quiz n'est pas sur cette page ──
  const overlay = document.getElementById('quiz-overlay');
  const trigger = document.getElementById('quiz-trigger');
  if (!overlay || !trigger) return;

  // ─── État ─────────────────────────────────────────────────────────
  const state = {
    currentStep: 1,
    answers: {},             // Q1, Q2, Q3, Q4, Q6 (single-choice)
    multiAnswers: { 5: [], 7: [] }, // Q5 et Q7 multi-select
    scores: { A: 0, B: 0, C: 0, D: 0 },
    intensiteScore: 0,
    winner: 'A'
  };

  // ─── Noms des profils ─────────────────────────────────────────────
  const profilNames = {
    A: 'Stress anxieux',
    B: 'Charge mentale',
    C: 'Stress physique',
    D: 'Stress émotionnel'
  };

  // ─── Scoring Q1 → intensité seulement ────────────────────────────
  const intensiteMap = {
    'rarement':     0,
    'parfois':      1,
    'souvent':      2,
    'tres-souvent': 3,
    'presque-tous': 4
  };

  // ─── Scoring Q2 → profil A uniquement ────────────────────────────
  const scoreQ2 = {
    'jamais':       0,
    'parfois':      1,
    'souvent':      2,
    'tres-souvent': 3,
    'tout-le-temps':4
  };

  // ─── Scoring Q3 → profil D uniquement ────────────────────────────
  const scoreQ3 = {
    'jamais':       0,
    'parfois':      1,
    'souvent':      2,
    'tres-souvent': 3,
    'tout-le-temps':4
  };

  // ─── Scoring Q4 → profil B uniquement ────────────────────────────
  const scoreQ4 = {
    'jamais':       0,
    'parfois':      1,
    'souvent':      2,
    'tres-souvent': 3,
    'tout-le-temps':4
  };

  // ─── Helpers ──────────────────────────────────────────────────────
  function goToStep(n) {
    document.querySelectorAll('.quiz-step').forEach(s => s.classList.remove('active'));
    const target = document.querySelector('.quiz-step[data-step="' + n + '"]');
    if (target) target.classList.add('active');
    // 7 barres de progression (steps 1–7 avant l'email = step 8)
    document.querySelectorAll('.progress-bar').forEach((bar, i) => {
      bar.classList.remove('active', 'completed');
      if (i + 1 <  n) bar.classList.add('completed');
      if (i + 1 === n) bar.classList.add('active');
    });
    state.currentStep = n;
    const c = document.querySelector('.quiz-container');
    if (c) c.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function showResult(profil) {
    document.querySelectorAll('.quiz-step').forEach(s => s.classList.remove('active'));
    document.querySelectorAll('.quiz-result').forEach(r => r.classList.remove('active'));
    const res = document.querySelector('.quiz-result[data-profile="' + profil + '"]');
    if (res) res.classList.add('active');
    document.querySelectorAll('.progress-bar').forEach(b => {
      b.classList.remove('active'); b.classList.add('completed');
    });
    const c = document.querySelector('.quiz-container');
    if (c) c.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function resetQuiz() {
    state.currentStep = 1;
    state.answers = {};
    state.multiAnswers = { 5: [], 7: [] };
    state.scores = { A: 0, B: 0, C: 0, D: 0 };
    state.intensiteScore = 0;
    state.winner = 'A';
    document.querySelectorAll('.quiz-option').forEach(b => b.classList.remove('selected'));
    document.querySelectorAll('.quiz-result').forEach(r => r.classList.remove('active'));
    const em = document.getElementById('quiz-email');
    const co = document.getElementById('quiz-consent');
    if (em) em.value = '';
    if (co) co.checked = false;
  }

  function openQuiz(isExitIntent) {
    overlay.classList.add('active');
    if (isExitIntent) overlay.classList.add('quiz-exit-intent');
    else              overlay.classList.remove('quiz-exit-intent');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    goToStep(state.currentStep || 1);
  }

  function closeOverlay() {
    overlay.classList.remove('active', 'quiz-exit-intent');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  // ─── Retour en arrière ────────────────────────────────────────────
  function goBack() {
    const n = state.currentStep;
    if (n <= 1) return;

    // Annuler la réponse de l'étape précédente
    const prevStep = n - 1;

    if (prevStep === 5) {
      // Multi Q5 : pas de scoring à annuler (C est recalculé à la soumission)
      // Juste effacer la sélection visuelle reste possible
    } else if (prevStep === 7) {
      // Multi Q7 : pas de scoring, juste navigation
    } else if (prevStep === 2 && state.answers[2] !== undefined) {
      state.scores.A -= scoreQ2[state.answers[2]] || 0;
      delete state.answers[2];
      document.querySelectorAll('.quiz-step[data-step="2"] .quiz-option')
        .forEach(btn => btn.classList.remove('selected'));
    } else if (prevStep === 3 && state.answers[3] !== undefined) {
      state.scores.D -= scoreQ3[state.answers[3]] || 0;
      delete state.answers[3];
      document.querySelectorAll('.quiz-step[data-step="3"] .quiz-option')
        .forEach(btn => btn.classList.remove('selected'));
    } else if (prevStep === 4 && state.answers[4] !== undefined) {
      state.scores.B -= scoreQ4[state.answers[4]] || 0;
      delete state.answers[4];
      document.querySelectorAll('.quiz-step[data-step="4"] .quiz-option')
        .forEach(btn => btn.classList.remove('selected'));
    } else if (prevStep === 1 && state.answers[1] !== undefined) {
      state.intensiteScore = 0;
      delete state.answers[1];
      document.querySelectorAll('.quiz-step[data-step="1"] .quiz-option')
        .forEach(btn => btn.classList.remove('selected'));
    } else if (prevStep === 6 && state.answers[6] !== undefined) {
      delete state.answers[6];
      document.querySelectorAll('.quiz-step[data-step="6"] .quiz-option')
        .forEach(btn => btn.classList.remove('selected'));
    }

    goToStep(prevStep);
  }

  // ─── Calcul du winner ─────────────────────────────────────────────
  function computeWinner() {
    const scoreC = state.multiAnswers[5].filter(v => v !== 'aucun').length;
    const candidates = {
      A: state.scores.A,
      B: state.scores.B,
      C: scoreC,
      D: state.scores.D
    };
    return Object.keys(candidates).reduce(function (a, b) {
      return candidates[a] >= candidates[b] ? a : b;
    });
  }

  // ─── Déterminer l'intensité ───────────────────────────────────────
  function computeIntensite() {
    const s = state.intensiteScore;
    if (s <= 1) return 'preventif';
    if (s === 2) return 'vigilance';
    return 'alerte';
  }

  // ─── Parallaxe hero (img element) ────────────────────────────────
  const heroBgImg = document.querySelector('.quiz-hero-bg-img');
  if (heroBgImg) {
    var heroSection = document.querySelector('.quiz-hero-section');
    var rafId = null;
    function updateParallax() {
      if (!heroSection) { rafId = null; return; }
      var rect   = heroSection.getBoundingClientRect();
      var winH   = window.innerHeight;
      if (rect.bottom < 0 || rect.top > winH) { rafId = null; return; }
      var raw    = rect.top * 0.10;
      var offset = Math.max(-50, Math.min(50, raw));
      heroBgImg.style.transform = 'translateY(' + offset + 'px)';
      rafId = null;
    }
    window.addEventListener('scroll', function () {
      if (!rafId) rafId = requestAnimationFrame(updateParallax);
    }, { passive: true });
    updateParallax();
  }

  // ─── Ouvrir (bouton CTA) ──────────────────────────────────────────
  trigger.addEventListener('click', function () { openQuiz(false); });

  // ─── Fermer (croix) ───────────────────────────────────────────────
  var closeBtn = document.querySelector('.quiz-close');
  if (closeBtn) closeBtn.addEventListener('click', closeOverlay);

  // ─── Clic sur le fond de l'overlay ───────────────────────────────
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closeOverlay();
  });

  // ─── Échap ────────────────────────────────────────────────────────
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('active')) closeOverlay();
  });

  // ─── Boutons Retour ───────────────────────────────────────────────
  document.querySelectorAll('.quiz-back-btn').forEach(function (btn) {
    btn.addEventListener('click', function () { goBack(); });
  });

  // ─── Boutons Recommencer ──────────────────────────────────────────
  document.querySelectorAll('.quiz-restart').forEach(function (btn) {
    btn.addEventListener('click', function () { resetQuiz(); closeOverlay(); });
  });

  // ─── Boutons Modifier mon email ───────────────────────────────────
  document.querySelectorAll('.quiz-edit-email').forEach(function (btn) {
    btn.addEventListener('click', function () {
      // Masquer tous les résultats
      document.querySelectorAll('.quiz-result').forEach(function (r) { r.classList.remove('active'); });
      // Vider l'email et décocher le consentement
      var emailEl = document.getElementById('quiz-email');
      var consentEl = document.getElementById('quiz-consent');
      if (emailEl) emailEl.value = '';
      if (consentEl) consentEl.checked = false;
      // Retourner à l'étape 8 (saisie email)
      goToStep(8);
    });
  });

  // ─── Single choice Q1 ────────────────────────────────────────────
  document.querySelectorAll('.quiz-step[data-step="1"] .quiz-option').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const val = btn.dataset.value;
      state.answers[1] = val;
      state.intensiteScore = intensiteMap[val] || 0;
      goToStep(2);
    });
  });

  // ─── Single choice Q2 → profil A ─────────────────────────────────
  document.querySelectorAll('.quiz-step[data-step="2"] .quiz-option').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const val = btn.dataset.value;
      state.answers[2] = val;
      state.scores.A += scoreQ2[val] || 0;
      goToStep(3);
    });
  });

  // ─── Single choice Q3 → profil D ─────────────────────────────────
  document.querySelectorAll('.quiz-step[data-step="3"] .quiz-option').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const val = btn.dataset.value;
      state.answers[3] = val;
      state.scores.D += scoreQ3[val] || 0;
      goToStep(4);
    });
  });

  // ─── Single choice Q4 → profil B ─────────────────────────────────
  document.querySelectorAll('.quiz-step[data-step="4"] .quiz-option').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const val = btn.dataset.value;
      state.answers[4] = val;
      state.scores.B += scoreQ4[val] || 0;
      goToStep(5);
    });
  });

  // ─── Multi-choice Q5 ─────────────────────────────────────────────
  document.querySelectorAll('[data-step="5"] .quiz-option').forEach(function (btn) {
    btn.addEventListener('click', function () {
      btn.classList.toggle('selected');
      const idx = state.multiAnswers[5].indexOf(btn.dataset.value);
      if (idx > -1) state.multiAnswers[5].splice(idx, 1);
      else          state.multiAnswers[5].push(btn.dataset.value);
    });
  });

  // ─── Valider Q5 ───────────────────────────────────────────────────
  const nextQ5 = document.getElementById('next-step-5');
  if (nextQ5) {
    nextQ5.addEventListener('click', function () {
      if (!state.multiAnswers[5] || !state.multiAnswers[5].length) {
        alert('Sélectionne au moins une réponse 😊'); return;
      }
      goToStep(6);
    });
  }

  // ─── Single choice Q6 → déclencheur (stocké, pas de scoring) ─────
  document.querySelectorAll('.quiz-step[data-step="6"] .quiz-option').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const val = btn.dataset.value;
      state.answers[6] = val;
      goToStep(7);
    });
  });

  // ─── Multi-choice Q7 ─────────────────────────────────────────────
  document.querySelectorAll('[data-step="7"] .quiz-option').forEach(function (btn) {
    btn.addEventListener('click', function () {
      btn.classList.toggle('selected');
      const idx = state.multiAnswers[7].indexOf(btn.dataset.value);
      if (idx > -1) state.multiAnswers[7].splice(idx, 1);
      else          state.multiAnswers[7].push(btn.dataset.value);
    });
  });

  // ─── Valider Q7 ───────────────────────────────────────────────────
  const nextQ7 = document.getElementById('next-step-7');
  if (nextQ7) {
    nextQ7.addEventListener('click', function () {
      if (!state.multiAnswers[7] || !state.multiAnswers[7].length) {
        alert('Sélectionne au moins une réponse 😊'); return;
      }
      goToStep(8);
    });
  }

  // ─── Soumettre l'email ────────────────────────────────────────────
  const submitBtn = document.getElementById('quiz-submit');
  if (submitBtn) {
    submitBtn.addEventListener('click', async function () {
      const emailEl   = document.getElementById('quiz-email');
      const consentEl = document.getElementById('quiz-consent');
      const email     = emailEl ? emailEl.value.trim() : '';
      const consent   = consentEl ? consentEl.checked : false;

      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        alert('Merci d\'entrer une adresse email valide.'); return;
      }
      if (!consent) {
        alert('Merci de cocher la case pour recevoir tes résultats.'); return;
      }

      submitBtn.disabled = true;
      submitBtn.textContent = 'Calcul en cours…';

      state.winner = computeWinner();
      // Appel parallèle : proxy (retire+réajoute) + événement Klaviyo
      await Promise.all([
        triggerFlowForExistingSubscribers(email),
        sendToKlaviyo(email, state.winner)
      ]);

      const emailSpans = document.querySelectorAll('#quiz-result-email');
      emailSpans.forEach(function (span) { span.textContent = email; });

      showResult(state.winner);

      submitBtn.disabled = false;
      submitBtn.textContent = 'Révèle mon profil ✨';
    });
  }

  // ─── Proxy Google Apps Script (retrait + réabonnement pour profils existants) ──
  // Remplace PROXY_URL par l'URL de ton Google Apps Script une fois déployé
  var KLAVIYO_PROXY_URL = window.quizStressSettings.proxyUrl || '';

  async function triggerFlowForExistingSubscribers(email) {
    if (!KLAVIYO_PROXY_URL) return;
    try {
      await fetch(KLAVIYO_PROXY_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email })
      });
    } catch(e) {
      console.warn('[Quiz] Proxy Klaviyo indisponible:', e);
    }
  }

  // ─── Klaviyo (Client API — clé publique UJY4Fq, CORS ok) ─────────
  async function sendToKlaviyo(email, profil) {
    const cfg    = window.quizStressSettings || {};
    const siteId = cfg.klaviyoKey || '';
    if (!siteId) {
      console.warn('[Quiz La pensée] Clé Klaviyo manquante — entre "UJY4Fq" dans les réglages de la section.');
      return;
    }

    const scoreC              = state.multiAnswers[5].filter(v => v !== 'aucun').length;
    const intensite           = computeIntensite();
    const declencheur         = state.answers[6] || '';
    const composantePhysique  = scoreC >= 2 && profil !== 'C';
    const strategieList       = state.multiAnswers[7] || [];

    const profileAttrs = {
      email: email,
      properties: {
        quiz_profil:              profilNames[profil],
        quiz_profil_code:         profil,
        quiz_intensite:           intensite,
        quiz_declencheur:         declencheur,
        quiz_composante_physique: composantePhysique,
        quiz_score_A:             state.scores.A,
        quiz_score_B:             state.scores.B,
        quiz_score_C:             scoreC,
        quiz_score_D:             state.scores.D,
        quiz_strategie:           strategieList.join(','),
        quiz_completed_at:        new Date().toISOString()
      }
    };

    const headers = { 'Content-Type': 'application/json', 'revision': '2024-10-15' };
    const base    = 'https://a.klaviyo.com/client/';

    // ── 1. Événement Quiz Complété — toujours déclenché, même pour les abonnés existants ──
    try {
      const resEvt = await fetch(base + 'events/?company_id=' + siteId, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
          data: {
            type: 'event',
            attributes: {
              metric: { data: { type: 'metric', attributes: { name: 'Quiz Complété' } } },
              profile: { data: { type: 'profile', attributes: profileAttrs } },
              properties: {
                profil_code:              profil,
                profil_nom:               profilNames[profil],
                intensite:                intensite,
                declencheur:              declencheur,
                composante_physique:      composantePhysique
              }
            }
          }
        })
      });
      if (resEvt.status === 202 || resEvt.ok) {
        console.log('[Quiz La pensée] Klaviyo — événement "Quiz Complété" OK pour', email);
      } else {
        const errTxt = await resEvt.text();
        console.error('[Quiz La pensée] Klaviyo event erreur', resEvt.status, errTxt);
      }
    } catch (e) {
      console.error('[Quiz La pensée] Erreur réseau Klaviyo (event):', e);
    }

    // ── 2. Abonnement à la liste email ────────────────────────────
    try {
      const resSub = await fetch(base + 'subscriptions/?company_id=' + siteId, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Quiz Profil de Stress',
              profile: { data: { type: 'profile', attributes: profileAttrs } }
            },
            relationships: {
              list: { data: { type: 'list', id: 'WR6tvE' } }
            }
          }
        })
      });
      if (resSub.status === 202 || resSub.ok) {
        console.log('[Quiz La pensée] Klaviyo — abonnement OK pour', email);
      } else {
        const errTxt = await resSub.text();
        console.error('[Quiz La pensée] Klaviyo abonnement erreur', resSub.status, errTxt);
      }
    } catch (e) {
      console.error('[Quiz La pensée] Erreur réseau Klaviyo (sub):', e);
    }
  }

  // ─────────────────────────────────────────────────────────────────
  //   EXIT-INTENT POPUP
  //   Conditions : activé dans les settings + pas déjà vu cette session
  // ─────────────────────────────────────────────────────────────────
  const settings = window.quizStressSettings || {};
  if (!settings.exitIntentEnabled) return;

  const SESSION_KEY = 'quiz_exit_shown';
  if (localStorage.getItem(SESSION_KEY)) return;

  let exitArmed = false;

  const armDelay = (settings.exitIntentDelay || 5) * 1000;
  setTimeout(function () { exitArmed = true; }, armDelay);

  function showExitIntent() {
    if (!exitArmed) return;
    if (overlay.classList.contains('active')) return;
    if (localStorage.getItem(SESSION_KEY)) return;   // déjà vu — ne jamais rouvrir
    localStorage.setItem(SESSION_KEY, '1');
    openQuiz(true);
  }

  // ── Desktop : souris sort par le haut ──
  document.addEventListener('mouseleave', function (e) {
    if (e.clientY <= 0) showExitIntent();
  });

  // ── Mobile : scroll rapide vers le haut ──
  let lastScrollY    = window.scrollY;
  let lastScrollTime = Date.now();

  window.addEventListener('scroll', function () {
    const now      = Date.now();
    const delta    = window.scrollY - lastScrollY;
    const elapsed  = now - lastScrollTime;
    const velocity = delta / elapsed;

    if (velocity < -1.5 && window.scrollY < 150) {
      showExitIntent();
    }

    lastScrollY    = window.scrollY;
    lastScrollTime = now;
  }, { passive: true });

})();
